<div class="date-time-field">
  <mat-form-field
    class="form-field form-field-date date-time-field-date"
    [class.readonly]="greyedOut"
    [floatLabel]="'auto'"
  >
    @if (label) {
      <mat-label>{{ label }}</mat-label>
    }
    <input
      matInput
      autocomplete="off"
      [matDatepicker]="datePicker"
      [formControl]="dateCtrl"
      [min]="minDate"
      [readonly]="readonly"
      [errorStateMatcher]="errorStateMatcher"
      (blur)="onTouched()"
    />
    <mat-datepicker-toggle class="btn-datepicker" matSuffix [for]="datePicker"></mat-datepicker-toggle>
    <mat-datepicker #datePicker [touchUi]="touchUi" (closed)="onTouched()"></mat-datepicker>
    <!-- The form field only shows errors it finds among its own content, so the caller's errors go inside this one. -->
    <mat-error><ng-content select="mat-error, .mat-error"></ng-content></mat-error>
  </mat-form-field>

  <mat-form-field
    class="form-field form-field-date date-time-field-time"
    [class.readonly]="greyedOut"
    [floatLabel]="'auto'"
  >
    <input
      matInput
      autocomplete="off"
      [matTimepicker]="timePicker"
      [formControl]="timeCtrl"
      [readonly]="readonly"
      [errorStateMatcher]="errorStateMatcher"
      (blur)="onTouched()"
    />
    <mat-timepicker-toggle class="btn-datepicker" matSuffix [for]="timePicker"></mat-timepicker-toggle>
    <mat-timepicker #timePicker [interval]="interval" (closed)="onTouched()"></mat-timepicker>
  </mat-form-field>
</div>
